import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internal-audit-report',
  templateUrl: './internal-audit-report.component.html',
  styleUrls: ['./internal-audit-report.component.scss']
})
export class InternalAuditReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
